module.exports = __webpack_public_path__ + "442d805acc787cdad1b63415d65146b2.webp";